module.exports = __webpack_public_path__ + "static/rents_spanish-2cc9f9005a7718250d2e4fe8db08bbf2.png";